import script from "./VitaSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaSearch.vue?vue&type=script&lang=ts&setup=true"

import "./VitaSearch.vue?vue&type=style&index=0&id=23cfced2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23cfced2"]])

export default __exports__